$(document).ready(function () {
    // gestion de la navigation
    hidePopinOptions();

    $('nav .entreprises').on('click', function (e) {
        e.preventDefault();
        togglePopin($(e.target).attr('data-popin'));
        // un remove it when offer is ready
        //hidePopinOptions();
    });
    $('nav .particuliers').on('click', function (e) {
        e.preventDefault();
        togglePopin($(e.target).attr('data-popin'));
    });

    $('nav #entreprise_type').change(function(e) {
        if($(this).val() == 'entreprise_avec_salaries') {
            $('#popin-nav-entreprises .activities').show();
            $('#popin-nav-entreprises .cta').show();
        } else if($(this).val() == 'entreprise_sans_salaries') {
            $('#popin-nav-entreprises .activities').hide();
        } else {
            $('#popin-nav-entreprises .activities').hide();
            $('#popin-nav-entreprises .cta').hide();
        }
    });

    $('nav .popin-nav label a').click(function(e) {
        var width = document.all?document.body.clientWidth:window.innerWidth;
        if(width > 812) {
            return false;
        } else {
            return true;
        }
    });

    // RIGHT STICKY BAR
    $('nav .main-nav .sticky .icon4').click(function(e) {
        e.preventDefault();

        // scroll to newsletter form
        window.scrollTo(0, (document.body.scrollHeight || document.documentElement.scrollHeight) - document.querySelector(".footer").scrollHeight);
    })

    $('.toTop').click(function(e) {
        e.preventDefault();

        // scroll to top page
        window.scrollTo(0, 0);
    })

    // CTA CIBLE
    $('section.cible a.cta').click(function (e) {
        e.preventDefault();
        togglePopin($(e.target).attr('data-popin'));
    });

    //NAVIGATION MOBILE
    $('.burger').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('nav').toggleClass('open_mobile')
        if ($('nav').hasClass('open_mobile')) {
           $('nav .main-nav').addClass('show')
        } else $('nav .main-nav').removeClass('show')
    });

    /*
    $('.sub_open').click(function (e) {
        e.preventDefault();
        $(this).next().toggleClass('open');
    });
    */

    $('.sub_bar_nav .cross').click(function (e) {
        e.preventDefault();
        togglePopin($(e.target).attr('data-popin'));
    });

    //search navigation
    $('nav #loupe').click(function (e) {
        e.preventDefault();
        $('nav .search').addClass('active');
        $('nav .search input[type="text"]').focus();
    });

    $('section.search .loupe').click(function (e) {
        e.preventDefault();
        $('section.search .field input[type="submit"]').click()
    });

    // Demande de devis
    $('#form-demande-de-devis-btn').click(function (e) {
        e.preventDefault();
        submitDevis();
    });

    // Inscription newsletter
    $('#form-inscription-newsletter-btn').click(function (e) {
        e.preventDefault();
        submitNewsletter();
    });

    // popin cible
    $('#form-entreprises-cible').submit(function (e) {
        e.preventDefault();
        submitCibleEntreprises();
    });

    $('#form-particuliers-cible').submit(function (e) {
        e.preventDefault();
        submitCibleParticuliers();
    });

    // Documents
    $('#form-document-filter input[type="checkbox"]').change(function () {
        getDocuments(false);
    });
    $('#form-document-filter select').change(function () {
        getDocuments(true);
    });
    if ($.contains(document, $('#form-document-filter-btn')[0])) {
        getDocuments(false);
    }

    // FAQ
    $('#form-faq-filter select[name="profil"]').change(function () {
        if($(this).val() == "entreprises") {
            $('select[name="activite_entreprises"]').removeClass('hide');
            $('select[name="activite_particuliers"]').addClass('hide');
        } else {
            $('select[name="activite_particuliers"]').removeClass('hide');
            $('select[name="activite_entreprises"]').addClass('hide');
        }
    });

    $('.faq-filter').change(function () {
        $('input[name="faq_page"]').val(1);
        getFaq();
    });

    if ($('#form-faq-filter').length > 0) {
        getFaq();
    }

    // Search
    if ($('#form-search').length > 0) {
        getSearch('all');
    }

    // Glossaire
    if ($('#glossaire').length > 0) {
        getGlossaire('all');
    }

    $('.glossaire-letters').click(function (e) {
        e.preventDefault();

        $('.glossaire-letters').removeClass('active');

        $(this).addClass('active');
        
        $('input[name="glossaire_page"]').val(1);
        $('input[name="glossaire_letter"]').val($(this).attr('data-letter'));
        getGlossaire();
    });

    $('.popinContent .close').click(function (e) {
        e.preventDefault();

        $(e.currentTarget).parent().parent().parent().hide();
    });

    function togglePopin(idPopin) {
        $('#popin-' + idPopin).toggleClass("show");

        if($('#popin-' + idPopin).hasClass("show")) {
            $('#popin-' + idPopin + ' .background').on('click', function (e) {
                e.preventDefault();
                togglePopin($(e.target).attr('data-popin'));
            });
            $('#popin-' + idPopin + ' .close').on('click', function (e) {
                e.preventDefault();
                togglePopin($(e.currentTarget).attr('data-popin'));
            });
        } else {
            $('#popin-' + idPopin + ' .background').off();
            $('#popin-' + idPopin + ' .close').off();
        }

        var width = document.all?document.body.clientWidth:window.innerWidth;
        if(width < 812 && $('.main-nav').hasClass('show') == false) {
            // on mobile version, go to top & open nav
            window.scrollTo(0, 0);
            //
            $('.burger').trigger('click');
        }
    }

    function hidePopinOptions() {
        if ($('select[name="entreprise_type"]').length > 0) {
            if($('select[name="entreprise_type"]').val() == '' || $('select[name="entreprise_type"]').val() == 'entreprise_sans_salaries') {
                $('#popin-nav-entreprises .activities').hide();
                $('#popin-nav-entreprises .cta').hide();
                $('#popin_title, #popin_options').hide();

                var width = document.all?document.body.clientWidth:window.innerWidth;
                if(width < 813) {
                    $('#popin-nav-entreprises .activities').show();
                }
            } else {
                var width = document.all?document.body.clientWidth:window.innerWidth;
                if(width > 812) {
                    $('#popin-nav-entreprises .activities').show();
                    $('#popin_title, #popin_options').show();
                    $('#popin-nav-entreprises .cta').show();
                } else {
                    $('#popin-nav-entreprises .activities').show();
                    $('#popin_title, #popin_options').show();
                    $('#popin-nav-entreprises .cta').hide();
                }
            }
        }
        $('select[name="entreprise_type"]').change(function () {
            if ($('option:selected', this).val() == '' || $('option:selected', this).val() == 'entreprise_sans_salaries') {
                $('#popin_title, #popin_options').hide();
                $('#popin-nav-entreprises .cta').click();
            } else {
                $('#popin_title, #popin_options').show();
            }
        });
    }
    
    function submitCibleEntreprises() {
        var url = "";
        if($('#entreprise_type').val() == 'entreprise_sans_salaries') {
            url = $('#entreprise_type').attr('data-page');
        } else {
            url = $('#form-entreprises-cible input[name=\'niv1\']:checked').val();
        }
        if(url) {
            document.location.href = url;
        }
    }

    function submitCibleParticuliers() {
        var url = "";
        url = $('#form-particuliers-cible input[name=\'niv1\']:checked').val();
        if(url) {
            document.location.href =url;
        }
    }

    function submitDevis() {
        var data = {
            'action': 'send_devis',
            'profil': $('#form-demande-de-devis input[name="profil"]:checked').val(),
            'date_de_naissance': $('#form-demande-de-devis input[name="date_de_naissance"]').val(),
            'situation': $('#form-demande-de-devis input[name="situation"]:checked').val(),
            'regime_dappartenance': $('#form-demande-de-devis input[name="regime_dappartenance"]:checked').val(),
            'adherent_a_la_carpillig': $('#form-demande-de-devis input[name="adherent_a_la_carpillig"]:checked').val(),
            'adresse_email': $('#form-demande-de-devis input[name="adresse_email"]').val(),
            'assurance_du_conjoint': $('#form-demande-de-devis input[name="assurance_du_conjoint"]').is(':checked') ? 1 : 0,
            'date_de_naissance_du_conjoint': $('#form-demande-de-devis input[name="date_de_naissance_du_conjoint"]').val(),
            'regime_dappartenance_du_conjoint': $('#form-demande-de-devis input[name="regime_dappartenance_du_conjoint"]:checked').val(),
            'nombre_denfants_a_assurer': $('#form-demande-de-devis select[name="nombre_denfants_a_assurer"] option:selected').val(),
            'date_de_naissance_enfant_1': $('#form-demande-de-devis input[name="date_de_naissance_enfant_1"]').val(),
            'date_de_naissance_enfant_2': $('#form-demande-de-devis input[name="date_de_naissance_enfant_2"]').val(),
            'date_de_naissance_enfant_3': $('#form-demande-de-devis input[name="date_de_naissance_enfant_3"]').val(),
            'date_de_naissance_enfant_4': $('#form-demande-de-devis input[name="date_de_naissance_enfant_4"]').val(),
            'date_de_naissance_enfant_5': $('#form-demande-de-devis input[name="date_de_naissance_enfant_5"]').val(),
            'date_de_naissance_enfant_6': $('#form-demande-de-devis input[name="date_de_naissance_enfant_6"]').val(),
            'date_de_naissance_enfant_7': $('#form-demande-de-devis input[name="date_de_naissance_enfant_7"]').val(),
            'date_de_naissance_enfant_8': $('#form-demande-de-devis input[name="date_de_naissance_enfant_8"]').val(),
            'date_de_naissance_enfant_9': $('#form-demande-de-devis input[name="date_de_naissance_enfant_9"]').val(),
            'date_de_naissance_enfant_10': $('#form-demande-de-devis input[name="date_de_naissance_enfant_10"]').val(),
            'consultation_de_medecin_avec_depassement_dhonoraires': $('#form-demande-de-devis select[name="consultation_de_medecin_avec_depassement_dhonoraires"] option:selected').val(),
            'besoin_optique': $('#form-demande-de-devis select[name="besoin_optique"] option:selected').val(),
            'besoin_en_prothese_dentaire': $('#form-demande-de-devis input[name="besoin_en_prothese_dentaire"]:checked').val(),
            'besoin_en_medecine_douce': $('#form-demande-de-devis input[name="besoin_en_medecine_douce"]:checked').val(),
            'besoin_prothese_auditive': $('#form-demande-de-devis input[name="besoin_prothese_auditive"]:checked').val(),
            'civilite': $('#form-demande-de-devis input[name="civilite"]:checked').val(),
            'nom': $('#form-demande-de-devis input[name="nom"]').val(),
            'prenom': $('#form-demande-de-devis input[name="prenom"]').val(),
            'adresse': $('#form-demande-de-devis input[name="adresse"]').val(),
            'code_postal': $('#form-demande-de-devis input[name="code_postal"]').val(),
            'ville': $('#form-demande-de-devis input[name="ville"]').val(),
            'numero_de_telephone': $('#form-demande-de-devis input[name="numero_de_telephone"]').val(),
            'type_de_contact': $('#form-demande-de-devis select[name="type_de_contact"] option:selected').val(),
            'message': $('#form-demande-de-devis textarea[name="message"]').val()
        };
    
        $.post('/wp-admin/admin-ajax.php', data, function (response) {
            console.log('success');
        });
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    
    function submitNewsletter() {
        var data = {
            'action': 'send_newsletter',
            'profil': $('#form-inscription-newsletter select[name="profil"] option:selected').val(),
            'adresse_email': $('#form-inscription-newsletter input[name="adresse_email"]').val()
        }

        $('#form-inscription-newsletter input[name="adresse_email"]').removeClass('error');
        $('#form-inscription-newsletter select[name="profil"]').removeClass('error');
    
        if (validateEmail(data.adresse_email) && data.profil) {
            // hide form
            $('section.footer .form').html('<img src="/wp-content/themes/lourmel/img/gray-loader.gif" />')
            
            $.post('/wp-admin/admin-ajax.php', data, function (response) {
                $('section.footer .form').html('Votre inscription est enregistrée.')
            });
        } else {
            if(!validateEmail(data.adresse_email)) {
                $('#form-inscription-newsletter input[name="adresse_email"]').addClass('error');
            }
            if(!data.profil) {
                $('#form-inscription-newsletter select[name="profil"]').addClass('error');
            }
        }
    }

    //close popin send document

    function getDocuments(mobile) {
        var results = $('#results');
        //results.fadeOut(200);
        results.html('<div class="loader"><img src="/wp-content/themes/lourmel/img/loader.gif" /></div>');
        if(mobile) {
            var data = {
                'action': 'get_documents',
                'profil': $('select[name="document-profil-filter[]"] option:selected').val()?'document-profil-filter%5B%5D='+$('select[name="document-profil-filter[]"] option:selected').val():"",
                'theme': $('select[name="document-theme-filter[]"] option:selected').val()?'document-theme-filter%5B%5D='+$('select[name="document-theme-filter[]"] option:selected').val():"",
                'page': $('input[name="document_page"]').val()
            };
        } else {
            var data = {
                'action': 'get_documents',
                'profil': $('input[name="document-profil-filter[]"]:checked').serialize(),
                'theme': $('input[name="document-theme-filter[]"]:checked').serialize(),
                'page': $('input[name="document_page"]').val()
            };
        }

        $.post('/wp-admin/admin-ajax.php', data, function (response) {
            results.html(response.results);

            //results.fadeIn(200);

            // Pagination events
            $('.document-page-link').click(function (e) {
                var page = $(this).attr('data-page');
                $('input[name="document_page"]').val(page);

                e.preventDefault();
                getDocuments();
            });
    
            // Share links events
            $('.document-share-link').click(function (e) {
                var popin = $('[doc-popup="popup"]');
                popin.addClass("open");
                popin.fadeIn(350);
                var document_id = $(this).attr('data-document-id');
                $('input[name="document_id"]').val(document_id);
                e.preventDefault();
            });
    
            // Share form event
            $('#form-document-share-btn').click(function (e) {
                e.preventDefault();
                shareDocument();
            });
        });
    }
    
    function shareDocument() {
        $('#form-document-share .email_false').hide()
        $('#form-document-share input[name="email"]').removeClass('error');
        
        if ($('#form-document-share input[name="document_id"]').val() !== '' && validateEmail($('#form-document-share input[name="email"]').val())) {
            // hide form
            $('#form-document-share #form-document-share-btn').hide();
            $('#form-document-share').append('<div class="loader"><img src="/wp-content/themes/lourmel/img/loader.gif" /></div>');
            
            
            var data = {
                'action': 'share_documents',
                'document_id': $('#form-document-share input[name="document_id"]').val(),
                'email': $('#form-document-share input[name="email"]').val()
            }
    
            $.post('/wp-admin/admin-ajax.php', data, function (response) {
                $('#form-document-share .loader').remove();
                $('#form-document-share .send').show();
                console.log("ok ")
                setTimeout(function () {
                    $('#form-document-share .send').hide();
                    $('#form-document-share #form-document-share-btn').show()
                },2000)
            });
        } else {
            $('#form-document-share input[name="email"]').addClass('error');
            $('#form-document-share .email_false').show();
        }
    
        return false;
    }
    
    function getFaq() {
        var results = $('#results');
        //results.fadeOut(200);
        results.html('<div class="loader"><img src="/wp-content/themes/lourmel/img/loader.gif" /></div>');

        var data = {
            'action': 'get_faq',
            'profil': $('#form-faq-filter select[name="profil"] option:selected').val(),
            'activite_entreprises': $('#form-faq-filter select[name="profil"] option:selected').val() == 'entreprises' ? $('#form-faq-filter select[name="activite_entreprises"] option:selected').val() : '',
            'activite_particuliers': $('#form-faq-filter select[name="profil"] option:selected').val() == 'particuliers' ? $('#form-faq-filter select[name="activite_particuliers"] option:selected').val() : '',
            'theme': $('#form-faq-filter select[name="theme"] option:selected').val(),
            'page': $('input[name="faq_page"]').val()
        }

        $.post('/wp-admin/admin-ajax.php', data, function (response) {
            $('#results').html(response.results);
            console.log(response.results)
            // Pagination events
            $('.faq-page-link').click(function (e) {
                var page = $(this).attr('data-page');
                $('input[name="faq_page"]').val(page);

                e.preventDefault();
                getFaq();
            });

            $( function() {
                $( "#accordion" ).accordion({
                    header: ".expand_bar",
                    icons: false,
                    collapsible: true
                });
            } );

        }).fail(function() {
            console.log("nothing");
        });
    }
    
    function getSearch(searchtype) {
        var resultsPost = $('#results-posts');
        var resultsDocuments =  $('#results-documents');

        //resultsPost.fadeOut(200);
        if(searchtype == "posts" || searchtype == "all") {
            resultsPost.html('<div class="result"><img src="/wp-content/themes/lourmel/img/white-loader.gif" /></div>');
        }  
        if(searchtype == "documents" || searchtype == "all") {
            resultsDocuments.html('<div class="result"><img src="/wp-content/themes/lourmel/img/loader.gif" /></div>');
        }
        
        var data = {
            'action': 'get_search',
            'search': $('input[name="search"]').val(),
            'search_type': searchtype,
            'posts_page': $('input[name="search_posts_page"]').val(),
            'documents_page': $('input[name="search_documents_page"]').val()
        }
    
        $.post('/wp-admin/admin-ajax.php', data, function (response) {
            if (response.posts_results !== '') {
                resultsPost.html(response.posts_results);
            }
    
            if (response.documents_results !== '') {
                resultsDocuments.html(response.documents_results);
            }
    
            // Pagination posts events
            $('.search-posts-page-link').click(function (e) {
                var page = $(this).attr('data-posts-page');
                $('input[name="search_posts_page"]').val(page);

                e.preventDefault();
                getSearch('posts');
            });

            // Pagination documents events
            $('.search-documents-page-link').click(function (e) {
                var page = $(this).attr('data-posts-page');
                $('input[name="search_documents_page"]').val(page);

                e.preventDefault();
                getSearch('documents');
            });
        });
    }
    
    function getGlossaire () {
        $('#results').html('<div class="result"><img src="/wp-content/themes/lourmel/img/loader.gif" /></div>');
        
        var data = {
            'action': 'get_glossaire',
            'letter': $('input[name="glossaire_letter"]').val(),
            'page': $('input[name="glossaire_page"]').val()
        }
    
        $.post('/wp-admin/admin-ajax.php', data, function (response) {
            $('#results').html(response.results);
    
            // Pagination events
            $('.glossaire-page-link').click(function (e) {
                var page = $(this).attr('data-page');
                $('input[name="glossaire_page"]').val(page);

                e.preventDefault();
                getGlossaire()
            });
        });
    }

    $(window).scroll(function() {
        var width = document.all ? document.body.clientWidth : window.innerWidth;
        var height = document.all ? document.body.clientHeight : window.innerHeight;

        if (width > 813) {
            if($(document).scrollTop() > 70) {
                $('header nav').addClass("reduced");
                $('header .sub_bar_nav').hide('slow');
                $('.toTop').addClass("show");
            } else {
                $('header nav').removeClass("reduced");
                $('header .sub_bar_nav').show('slow');
                $('.toTop').removeClass("show");
            }
        }

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
            isMobile = true;
        }
        if(isMobile || width < 813) {
            if($(document).scrollTop() == 0) {
                $('header .sub_bar_nav').show();
            } else {
                $('header .sub_bar_nav').hide();
            }
            
            $('.mosaique ul li').each(function(index, val) {
                if(($(this).offset().top - height/2) < $(document).scrollTop() && ($(this).offset().top) > $(document).scrollTop()) {
                    $(this).addClass('over')
                } else {
                    if($(this).hasClass('over')) {
                        $(this).removeClass('over');
                    }
                }
            });
        }
    });

/*    //CUSTOM SELECT
    $('select').each(function(){
            var $this = $(this), numberOfOptions = $(this).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());

            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function(e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function(){
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.click(function(e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $('#moteur option[value="essence"]').prop('selected', true);
                $list.hide();
                //console.log($this.val());
            });

            $(document).click(function() {
                $styledSelect.removeClass('active');
                $list.hide();
            });

    });*/

    function loadScript(url, callback, is_async)
    {
        // Adding the script tag to the head as suggested before
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = is_async;
        script.onreadystatechange = callback;
        script.onload = callback;
        head.appendChild(script);
    }
    var tarteaucitronInit = function() {
        tarteaucitron.init({
            "hashtag": "#tarteaucitron",
            "highPrivacy": false,
            "orientation": "bottom",
            "adblocker": false,
            "showAlertSmall": true,
            "cookieslist": true,
            "removeCredit": false
        });

        tarteaucitron.user.googletagmanagerId = 'GTM-5LMTJ4V';
        (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
    };
    loadScript('/wp-content/themes/lourmel/tarteaucitron/tarteaucitron.js', tarteaucitronInit, true);
});


// WEBPACK FOOTER //
// ./js/script.js